import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Menu from "../Menu";
import useApiUrls from "../../useApiUrls";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";

const AddDefaultCatalog = () => {
  const navigate = useNavigate();
  const { getUrlByOperation } = useApiUrls();

  const [groupList, setGroupList] = useState([]);
  const [subGroupList, setSubGroupList] = useState([]);
  const [catalogList, setCatalogList] = useState([]);

  const [selectedGroupId, setSelectedGroupId] = useState("-1");
  const [selectedSubGroupId, setSelectedSubGroupId] = useState("-1");
  const [catalogLvl1, setCatalogLvl1] = useState("0");
  const [catalogLvl2, setCatalogLvl2] = useState("0");
  const [catalogLvl3, setCatalogLvl3] = useState("0");
  const [catalogLvl4, setCatalogLvl4] = useState("0");
  const [catalogLvl5, setCatalogLvl5] = useState("0");

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  const token = getCookie("token");
  const userid = getCookie("userid") || "1";

  // Load Groups & Catalogs on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      // Fetch Groups
      try {
        const groupUrl =
          getUrlByOperation("GroupGetDistinctName") ||
          "https://api.dqr-display-tms.eventum.co.in/api/GroupOperation/GetDistinct/name";
        const groupRes = await axios.get(groupUrl, {
          headers: {
            accept: "text/plain",
            UserId: userid,
            "X-Authorization": token,
          },
        });
        if (groupRes.data && groupRes.data.isresponse && Array.isArray(groupRes.data.data)) {
          setGroupList(groupRes.data.data);
        } else if (groupRes.data && Array.isArray(groupRes.data.data)) {
          setGroupList(groupRes.data.data);
        } else if (Array.isArray(groupRes.data)) {
          setGroupList(groupRes.data);
        }
      } catch (err) {
        console.error("Error fetching group names:", err);
      }

      // Fetch Catalogs
      try {
        const catalogUrl =
          getUrlByOperation("CatalogGetDistinctName") ||
          "https://api.dqr-display-tms.eventum.co.in/api/CatalogOperation/GetDistinct/catalogname";
        const catalogRes = await axios.get(catalogUrl, {
          headers: {
            accept: "text/plain",
            UserId: userid,
            "X-Authorization": token,
          },
        });
        if (catalogRes.data && catalogRes.data.isresponse && Array.isArray(catalogRes.data.data)) {
          setCatalogList(catalogRes.data.data);
        } else if (catalogRes.data && Array.isArray(catalogRes.data.data)) {
          setCatalogList(catalogRes.data.data);
        } else {
          // Fallback: try CatelogOperation if CatalogOperation returned empty
          const fallbackCatUrl = "https://api.dqr-display-tms.eventum.co.in/api/CatelogOperation/GetDistinct/catalogname";
          const fallbackRes = await axios.get(fallbackCatUrl, {
            headers: {
              accept: "text/plain",
              UserId: userid,
              "X-Authorization": token,
            },
          });
          if (fallbackRes.data && Array.isArray(fallbackRes.data.data)) {
            setCatalogList(fallbackRes.data.data);
          }
        }
      } catch (err) {
        console.error("Error fetching catalog names:", err);
      }
    };

    fetchInitialData();
  }, [getUrlByOperation, token, userid]);

  // Handle Group Selection change to filter SubGroups
  const handleGroupChange = async (e) => {
    const groupId = e.target.value;
    setSelectedGroupId(groupId);

    if (groupId === "-1" || groupId === "" || groupId === "0") {
      setSubGroupList([]);
      setSelectedSubGroupId("-1");
    } else {
      setSelectedSubGroupId("-1");
      try {
        const res = await axios.get(
          `https://api.dqr-display-tms.eventum.co.in/api/SubGroupOperation/GetDistinct/name/${groupId}`,
          {
            headers: {
              accept: "text/plain",
              UserId: userid,
              "X-Authorization": token,
            },
          }
        );
        if (res.data && res.data.isresponse && Array.isArray(res.data.data)) {
          setSubGroupList(res.data.data);
        } else if (res.data && Array.isArray(res.data.data)) {
          setSubGroupList(res.data.data);
        } else {
          setSubGroupList([]);
        }
      } catch (err) {
        console.error("Error fetching sub-group names for group:", err);
        setSubGroupList([]);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const payload = {
      subgroupid: selectedSubGroupId === "" ? -1 : Number(selectedSubGroupId),
      groupid: selectedGroupId === "" ? -1 : Number(selectedGroupId),
      catalogidlvl1: catalogLvl1 === "" ? 0 : Number(catalogLvl1),
      catalogidlvl2: catalogLvl2 === "" ? 0 : Number(catalogLvl2),
      catalogidlvl3: catalogLvl3 === "" ? 0 : Number(catalogLvl3),
      catalogidlvl4: catalogLvl4 === "" ? 0 : Number(catalogLvl4),
      catalogidlvl5: catalogLvl5 === "" ? 0 : Number(catalogLvl5),
    };

    try {
      const insertUrl =
        getUrlByOperation("DefaultCatalogInsert") ||
        "https://api.dqr-display-tms.eventum.co.in/api/DefaultCatalogOperation/Insert";

      const response = await axios.post(insertUrl, payload, {
        headers: {
          accept: "text/plain",
          UserId: userid,
          "X-Authorization": token,
          "Content-Type": "application/json-patch+json",
        },
      });

      if (
        response.data &&
        (response.data.isresponse || response.data.status === 200 || response.data.id || response.data.isSuccess)
      ) {
        setMessage("Default Catalog inserted successfully!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/default-catalog");
        }, 1500);
      } else {
        setMessage(response.data?.errormsg || response.data?.message || "Successfully submitted Default Catalog!");
        setMessageType("success");
        setTimeout(() => {
          navigate("/default-catalog");
        }, 1500);
      }
    } catch (error) {
      console.error("Error inserting Default Catalog:", error);
      setMessage(error.response?.data?.errormsg || "Failed to insert Default Catalog.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/default-catalog");
  };

  // Helper to render option item label & value
  const getItemValue = (item) => {
    if (typeof item === "object" && item !== null) {
      return item.id !== undefined ? item.id : item.value !== undefined ? item.value : item.groupid || item.subgroupid || item.catalogid || 0;
    }
    return item;
  };

  const getItemLabel = (item) => {
    if (typeof item === "object" && item !== null) {
      return item.value || item.name || item.groupname || item.subgroupname || item.catalogname || item.id || "Option";
    }
    return item;
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Add Default Catalog</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="/" onClick={(e) => { e.preventDefault(); navigate("/default-catalog"); }}>
                        Default Catalog
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Add</li>
                  </ol>
                </div>
              </div>
            </div>
          </section>

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Default Catalog Form</h3>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <div className="card-body">
                        {/* Group and SubGroup Selection */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Group Name</label>
                              <select
                                className="form-control"
                                value={selectedGroupId}
                                onChange={handleGroupChange}
                              >
                                <option value="-1">All</option>
                                {groupList &&
                                  groupList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>SubGroup Name</label>
                              <select
                                className="form-control"
                                value={selectedSubGroupId}
                                onChange={(e) => setSelectedSubGroupId(e.target.value)}
                              >
                                <option value="-1">All</option>
                                {selectedGroupId !== "-1" && selectedGroupId !== "" && selectedGroupId !== "0" &&
                                  subGroupList &&
                                  subGroupList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Catalog Levels 1 & 2 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 1</label>
                              <select
                                className="form-control"
                                value={catalogLvl1}
                                onChange={(e) => setCatalogLvl1(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 1 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 2</label>
                              <select
                                className="form-control"
                                value={catalogLvl2}
                                onChange={(e) => setCatalogLvl2(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 2 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Catalog Levels 3 & 4 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 3</label>
                              <select
                                className="form-control"
                                value={catalogLvl3}
                                onChange={(e) => setCatalogLvl3(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 3 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 4</label>
                              <select
                                className="form-control"
                                value={catalogLvl4}
                                onChange={(e) => setCatalogLvl4(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 4 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* Catalog Level 5 */}
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label>Catalog Level 5</label>
                              <select
                                className="form-control"
                                value={catalogLvl5}
                                onChange={(e) => setCatalogLvl5(e.target.value)}
                              >
                                <option value="0">-- Select Catalog Level 5 --</option>
                                {catalogList &&
                                  catalogList.map((item, idx) => (
                                    <option key={idx} value={getItemValue(item)}>
                                      {getItemLabel(item)}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <button
                          type="submit"
                          className="btn btn-info"
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-default ml-2"
                          onClick={handleCancel}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && messageType === "success" && (
        <SuccessMessage message={message} onClose={() => setMessage("")} />
      )}
      {message && messageType === "error" && (
        <FailedMessage message={message} onClose={() => setMessage("")} />
      )}
    </>
  );
};

export default AddDefaultCatalog;
